export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200/50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">蓝莓影院</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              高清免费在线观影平台。海量免费电视剧全集、最新电影大全，不缓冲流畅播放，每日更新热门影视资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '专题聚焦', href: '#carousel' },
                { label: '精选推荐', href: '#media' },
                { label: '剧集索引', href: '#index' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">更多内容</h4>
            <div className="space-y-2">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
                { label: '最新动态', href: '#updates' },
                { label: '联系我们', href: '#contact' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              敬请期待合作品牌入驻
            </p>
            <div className="flex items-center gap-3 mt-4">
              <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-wechat-line text-sm text-foreground-500"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-weibo-line text-sm text-foreground-500"></i>
              </div>
              <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center cursor-pointer hover:bg-primary-100 transition-colors duration-200">
                <i className="ri-bilibili-line text-sm text-foreground-500"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2024-2026 蓝莓影院 版权所有 | 高清免费在线观影平台
          </p>
          <p className="text-xs text-foreground-300">
            每日更新 · 即点即看 · 流畅不卡
          </p>
        </div>
      </div>
    </footer>
  );
}